// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__2Qh+R","Flag":"Logo_Flag__X9-gK"};